import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconPlanet: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0.5C3.58172 0.5 0 4.08172 0 8.5C1.93129e-07 12.9183 3.58172 16.5 8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5V0.5ZM8 2.1C8.48206 2.10315 8.96231 2.15949 9.432 2.268V2.268C9.29294 2.58191 9.07861 2.85669 8.808 3.068C8.632 3.204 8.44 3.316 8.248 3.436L8.248 3.436C7.64018 3.73526 7.12771 4.19788 6.768 4.772C6.37395 5.59326 6.20289 6.50373 6.272 7.412C6.272 8.5 6.272 9.14 5.512 9.708C4.416 10.564 2.744 10.084 1.704 9.652V9.652C1.63601 9.27174 1.60121 8.88629 1.6 8.50001V8.50001C1.6 4.96538 4.46538 2.10001 8 2.10001V2.1ZM11.912 13.556C11.7736 13.2366 11.6048 12.9311 11.408 12.644C11.32 12.516 11.232 12.388 11.152 12.252C10.84 11.708 10.952 11.452 11.456 10.652L11.536 10.516C11.8606 9.92073 12.0208 9.24971 12 8.572V8.57196C11.9992 8.30364 12.0233 8.03583 12.072 7.77196C12.2 7.18796 13.44 7.02796 14.208 6.97196C14.8425 9.439 13.9419 12.0465 11.92 13.596L11.912 13.556Z" />
    </svg>
  </IconStyled>
);

IconPlanet.defaultProps = iconDefaultProps;
IconPlanet.displayName = 'IconPlanet';

export default IconPlanet;
